export enum AssessmentType {
    ASSESSMENT = 'ASSESSMENT',
    INITIATIVE = 'INITIATIVE',
}
